import React, { useState} from "react";
import JsCodeEditor from "../../../components/JsCodeEditor";
import { toast } from 'react-toastify'; 

const SettingsTab = ({updateInstagramFeedTabData,instagramFeedTabData}) => {
    const [activeSettingTab, setActiveSettingTabsElements] = useState("main");
    const [language, setLanguage] = useState(instagramFeedTabData.language_type);
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(instagramFeedTabData.custom_js);
   
    // Handlers Language type Change
    const handleLanguageChange = (type) => {
        setLanguage(type);
        updateInstagramFeedTabData("language_type", type);
        setLanguageDropdownOpen(false);
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateInstagramFeedTabData("custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };
    
    return (
        <div className="side-baar-inner-setting">
            {activeSettingTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Language</span>
                            <div className="color-pikr-box" onClick={() => setLanguageDropdownOpen(!languageDropdownOpen)}>
                                <em>{language}</em>
                                {languageDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["English"].map((type) => (
                                            <li key={type} onClick={() => handleLanguageChange(type)}>
                                                {type}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>      
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveSettingTabsElements("custome_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingTab === "custome_js" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom JS Editor</span>
                        <div className="css-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <button className="validate" onClick={handleValidateClick}>Validate</button>
                        </div>
                        <p>Tip: It is recommended to use the CSS classes with the “es” prefix, as these are specially designed for stable customization. Please note, while these classes are intended to be more static, we cannot guarantee that they will remain unchanged in future updates.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingsTab;